<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <TabMenu :menuIndex="menuIndex" :menu="menu" />

    <div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      breadcrumb: [
        { name: "人员管理" },
        { name: "车务管理" },
      ],
      menuIndex: `/staff/vehicleService/table`,
      menu: [
        {
          name: "在职",
          path: `/staff/vehicleService/table/1`,
        },
        {
          name: "离职",
          path: `/staff/vehicleService/table/2`,
        },
        {
          name: "冻结",
          path: `/staff/vehicleService/table/3`,
        },
      ],
    };
  },
  methods: {},
  watch: {
    $route() {
      this.menuIndex = this.$route.path
    },
  },
  mounted() {
    this.menuIndex = `${this.$route.path}`
  },
};
</script>
